import PropTypes from "prop-types";
import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { Container } from "./container";
import { Link } from 'react-router-dom';
import Logo from "../../assets/image/logo.png";
import "./header.css";

const Header = () => {
  const [mobileNav, setMobileNav] = useState(false);
  // const headerEl = useRef();
  // if (typeof window !== `undefined`) {
  //   let prevScrollPosition = window.pageYOffset;
  //   window.addEventListener("scroll", () => {
  //     const curScrollPosition = window.pageYOffset;
  //     const difference = prevScrollPosition - curScrollPosition;
  //     let { current } = headerEl;
  //     console.log('headerEl', headerEl);
  //     console.log('current', current);
  //     setMobileNav(false);
  //     if (curScrollPosition > 100) {
  //       console.log('current', current, current.classList);
  //       current.classList.add("compaq");
  //     } else {
  //       current.classList.remove("compaq");
  //     }
  //     if (difference < 0) {
  //       current.classList.add("hide");
  //     } else {
  //       current.classList.remove("hide");
  //     }
  //     prevScrollPosition = curScrollPosition;
  //   });
  // }

  const handleScroll = e => {
    e.preventDefault();
    const hash = e.target.hash;
    const el = document.querySelector(hash);
    const offsetTop = el.offsetTop;
    setMobileNav(false);
    if (typeof window !== `undefined`) {
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <header>
      <Container padding="25px 25px">
        <div className="header">
          <div className="logo">
            <h1>
              <Link to="/" style={{ color: "#00cf5d" }}>
                {/* <Logo /> */}
                <img src={Logo} alt='logo' height='40px' width='40px' />
              </Link>
            </h1>
          </div>
          <div onClick={() => setMobileNav(!mobileNav)} className="mobile-nav">
            <FaBars />
          </div>
          <ul className={`menubar ${mobileNav ? "mobilenav-activate" : ""}`}>
            <li>
              <a onClick={handleScroll} href="#about">
                About
              </a>
            </li>
            <li>
              <a onClick={handleScroll} href="#skill">
                Skill
              </a>
            </li>
            <li>
              <a onClick={handleScroll} href="#portfolio">
                Portfolio
              </a>
            </li>
            <li>
              <a onClick={handleScroll} href="#contact">
                Contact
              </a>
            </li>
            <li>
              <a
                className="btn-download"
                target="_blank"
                rel="noopener noreferrer"
                href="https://drive.google.com/file/d/1UL0y6WN06WBpp_PhItpBqN-xjFarXLTv/view?usp=sharing"
              >
                Resume
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export { Header };